import React from "react";
import { MDCAnchorMenu, MDCMenu } from "../../jsx/components/mdc-components";
export class ActivityRangeMenu extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "today",
      "data-id": "today"
    }, "Today"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "yesterday",
      "data-id": "yesterday"
    }, "Yesterday"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_week",
      "data-id": "this_week"
    }, "This Week"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_week",
      "data-id": "last_week"
    }, "Last Week"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_month",
      "data-id": "this_month"
    }, "This Month"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_month",
      "data-id": "last_month"
    }, "Last Month"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_quarter",
      "data-id": "this_quarter"
    }, "This Quarter"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_quarter",
      "data-id": "last_quarter"
    }, "Last Quarter"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_year",
      "data-id": "today"
    }, "This Year"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_year",
      "data-id": "today"
    }, "Last Year"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "all_time",
      "data-id": "all_time"
    }, "All Time")));
  }
}
export class ActivityCustomRangeMenu extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, this.props.children));
  }
}
export class ActivityComparisonMenu extends React.Component {
  render() {
    var selection = this.props.selection;
    var itemCss = 'mdc-list-item';
    var lastItemCss = 'mdc-list-item';
    if (this.props.hide) {
      itemCss += ' hide';
      selection = 'Unavailable';
    } else {
      lastItemCss += ' hide';
    }
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: itemCss,
      role: "menuitem",
      tabIndex: "0",
      "data-value": "prev_year",
      "data-id": "prev_year"
    }, "Previous Year"), /*#__PURE__*/React.createElement("li", {
      className: itemCss,
      role: "menuitem",
      tabIndex: "0",
      "data-value": "prev_period",
      "data-id": "prev_period"
    }, "Previous Period"), /*#__PURE__*/React.createElement("li", {
      className: lastItemCss,
      role: "menuitem",
      tabIndex: "0",
      "data-value": "unavailable",
      "data-id": "unavailable"
    }, "Unavailable")));
  }
}
export default {
  ActivityRangeMenu,
  ActivityCustomRangeMenu,
  ActivityComparisonMenu
};